import { render, staticRenderFns } from "./XMultiselect.vue?vue&type=template&id=9d1d7640&"
import script from "./XMultiselect.vue?vue&type=script&lang=js&"
export * from "./XMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./XMultiselect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports